;(() => {
  const throttle = (callback, delay) => {
    let time = Date.now()

    return (...args) => {
      if (time + delay - Date.now() <= 0) {
        callback(...args)
        time = Date.now()
      }
    }
  }

  const headerElement = document.querySelector('header.global-header')
  const htmlElement = document.querySelector('html')

  //show the header when mouse is moved towards it
  document.addEventListener(
    'mousemove',
    throttle((event) => {
      if (event.clientY <= 100) {
        htmlElement.classList.remove('hide-header')
      }
    }, 500)
  )

  let lastKnownScrollY = 0
  document.addEventListener(
    'scroll',
    throttle(() => {
      const scrollY = window.scrollY
      htmlElement.classList.toggle(
        'hide-header',
        scrollY > lastKnownScrollY && scrollY > 200
      )
      lastKnownScrollY = scrollY

      //catches the edge case where the user scrolls to the top of the page quickly
      setTimeout(() => {
        if (window.scrollY === 0) {
          htmlElement.classList.remove('hide-header')
        }
      }, 200)
    }, 200)
  )
})()
